<!--
 * @Author: mobai
 * @Date: 2022-08-30 11:58:35
 * @LastEditors: mobai
 * @LastEditTime: 2022-09-15 10:48:49
 * @FilePath: \qym-lishui\src\gov\views\yardVoucher\whitelistLog\logList.vue
-->
<template>
  <div class="app-container">
    <div class="header">
      <div class="header-search">
        <el-input
          v-model="key"
          placeholder="搜索用户姓名"
          clearable
          @keyup.enter.native="getSearch"
          @clear="getSearch"
        >
          <i
            slot="suffix"
            @click="getSearch"
            class="el-input__icon el-icon-search"
          ></i>
        </el-input>
        <el-date-picker
          v-model="operationTime"
          type="daterange"
          range-separator="至"
          start-placeholder="操作开始日期"
          end-placeholder="操作结束日期"
          value-format="yyyy-MM-dd"
          @change="changeTime"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="list">
      <el-table :data="listData" style="width: 100%">
        <el-table-column type="index" label="序号" width="80px">
        </el-table-column>
        <el-table-column property="opertator" label="操作人"> </el-table-column>
        <el-table-column property="entWhiteYear" label="白名单年份">
          <template slot-scope="scope">
            <div>{{ scope.row.entWhiteYear || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column property="entName" label="企业名称"> </el-table-column>
        <el-table-column property="creditCode" label="统一社会信用代码">
        </el-table-column>
        <el-table-column property="operateTime" label="操作时间">
        </el-table-column>
        <el-table-column label="操作">
          <template>
            <div><span class="circle"></span> 删除企业</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { examWhiteRecordPage } from '@api/yardVoucher/whiteLog/index'
export default {
  name: 'Log',
  data() {
    return {
      key: '',
      listData: [{}],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      startTime: '',
      entTime: '',
      operationTime: []
    }
  },
  mounted() {
    this.getSearch()
  },
  methods: {
    // 搜索
    getSearch() {
      let params = {
        key: this.key,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        startTime: this.startTime,
        entTime: this.entTime
      }
      examWhiteRecordPage(params)
        .then((res) => {
          const { code, data } = res.data
          if (code == '0000') {
            this.listData = data.results
            this.total = data.totalRecord
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeTime(data) {
      this.pageNum = 1
      this.startTime = data ? data[0] : ''
      this.entTime = data ? data[1] : ''
      this.getSearch()
    },
    handleSizeChange(data) {
      this.pageSize = data
      this.getSearch()
    },
    handleCurrentChange(data) {
      this.pageNum = data
      this.getSearch()
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  &-search {
    .el-input {
      width: 300px;
      margin-right: 30px;
    }
  }
}
.list {
  margin-top: 20px;
  .table-page {
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .circle {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: red;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>
